import React from "react";

const CompaniesSection = () => {
  const data = [
    { n: 1, name: "mindera", link: "https://mindera.com/" },
    { n: 2, name: "vodafone", link: "https://www.vodafone.com/" },
    { n: 5, name: "wolt", link: "https://wolt.com/" },
    { n: 3, name: "vocovo", link: "https://www.vocovo.com/" },
    { n: 4, name: "finimize", link: "https://finimize.com/" },
  ];

  return (
    <section
      id="CompaniesSection"
      className="flex flex-col items-center justify-between space-y-8 pt-16 pb-2"
    >
      <div className="space-y-8">
        <h1 className="text-4xl text-center leading-tight">
          Brands I’ve Helped <span>🤝</span>
        </h1>
      </div>
      <ul className="mx-auto flex flex-row items-center justify-center p-4 space-x-10 lg:max-w-[11946px]">
        {data.map((icon, i) => {
          return (
            <li
              key={i}
              className="cursor-pointer flex flex-col items-center justify-center"
              onClick={() => window.open(icon.link, "_blank")}
              data-umami-event={`clicked-${icon.name}-logo-block`}
            >
              <img
                alt="skills-icon"
                src={`/images/companies/${icon.n}.png`}
                className="w-48"
              ></img>
            </li>
          );
        })}
      </ul>
    </section>
  );
};

export default CompaniesSection;
